import React, {FC} from 'react';
import  './index.scss';

// interface CircleCheckboxProps {
//     value: string;
//     className?: string;
// }


export const CircleCheckbox: FC<any> = (props) => {
    return (
        <input 
          className="input-checkbox" 
          id="createaccount"
          checked={props.checked}
          onChange={props.onCheckboxChange}
          type="checkbox" 
          name="createaccount" value="1" onClick={props.handleCheckboxClick}/>
    );
};
